import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { Domain } from "@/store/user-management/types";
import { AxiosResponse } from "axios";

class ImmixCloudV2ApiHttpCCure {
	private axios: any;
	private axiosJson: any;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async getAllDomains(): Promise<Domain[]> {
		let response: AxiosResponse<Domain[]> = await this.axios.get(`/Domain/GetDomains`);

		if (response.status === 200) {
			return response.data;
		} else {
			return null;
		}
	}

	public async createDomain(domain: Domain): Promise<AxiosResponse<Domain>> {
		return (await this.axios.post("/Domain/CreateDomain", domain)).data;
	}

	public async updateDomain(domain: Domain): Promise<AxiosResponse<Domain>> {
		return (await this.axios.put("/Domain/UpdateDomain", domain)).data;
	}

	public async deleteDomain(domainId: number): Promise<void>{
		await this.axiosJson.delete(`/Domain/${domainId}`);
	}
}

const domainsApi = new ImmixCloudV2ApiHttpCCure();
export default domainsApi;
